import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const GameHeader = ({ roomId, onCopySuccess, showCopied, currentRound }) => {
    const shareUrl = `${window.location.origin}/room/${roomId}`;

    const handleTitleClick = (e) => {
        e.preventDefault();
        window.location.href = '/';
    };

    return (
        <header className="game-header">
            <div className="header-content">
                <div className="header-left">
                    <a href="/" onClick={handleTitleClick} className="game-title">Guess What?!</a>
                    {currentRound > 0 && (
                        <span className="round-counter">Round {currentRound}</span>
                    )}
                </div>
                <div className="header-info">
                    <CopyToClipboard text={shareUrl} onCopy={onCopySuccess}>
                        <button className="invite-button">
                            <span className="invite-icon">👯</span>
                            Room Invite
                            <span className="room-code-inline">{roomId}</span>
                            {showCopied && <span className="copied-tooltip">Copied invite link!</span>}
                        </button>
                    </CopyToClipboard>
                </div>
            </div>
        </header>
    );
};

export default GameHeader; 